<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount } from 'vue'
import ModalDialog from "../../../compositions/ModalDialog.vue";
import OrderListComponent from "./OrderType/OrderListComponent.vue";
import OrderHoldListComponent from "./OrderType/OrderHoldListComponent.vue";
import OrderPackListComponent from "./OrderType/OrderPackListComponent.vue";
import OrderWaitListComponent from "./OrderType/OrderWaitListComponent.vue";
import OrderDefectListComponent from "./OrderType/OrderDefectListComponent.vue";
import OrderTodayListComponent from "./OrderType/OrderTodayListComponent.vue";
import OrderTodayPackListComponent from "./OrderType/OrderTodayPackListComponent.vue";
import config from "../../../config.js";
import { errorAlert } from "../../../plugins/alert";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import { useOrderStore } from '../../../stores/order';
import HelpAction from '../../../compositions/HelpAction.vue';
import Breakpoint from "../../../compositions/Breakpoint.vue";

const order = useOrderStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    params:{
      type:Object,
      default:() => {
        return null;
      }
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})

const activeTab = ref('');
const activeTabs = [
  {id:'order',tab_name:"発注",tab_class:'order_tab_help',icon:"M2.5,0C1.09,0,0,1.09,0,2.5v15c0,1.41,1.09,2.5,2.5,2.5H12.5c1.41,0,2.5-1.09,2.5-2.5V6.2h-5c-.65,0-1.3-.54-1.3-1.3V0H2.5Zm7.5,0V5h5L10,0Zm-1.52,15.98c0,.54-.43,.98-.98,.98s-.98-.43-.98-.98v-4.02l-1.2,1.2c-.33,.33-.98,.33-1.3,0-.33-.33-.33-.98,0-1.3l2.83-2.83c.33-.33,.98-.33,1.3,0l2.83,2.83c.33,.33,.33,.98,0,1.3s-.98,.33-1.3,0l-1.2-1.2v4.02h0Z"},
  {id:'hold',tab_name:"保留",tab_class:'order_hold_tab_help',icon:"M8.5,17.01c4.7,0,8.5-3.81,8.5-8.5S13.2,0,8.5,0,0,3.81,0,8.5s3.81,8.5,8.5,8.5Zm-1.06-10.63v4.25c0,.59-.48,1.06-1.06,1.06s-1.06-.48-1.06-1.06V6.38c0-.59,.48-1.06,1.06-1.06s1.06,.48,1.06,1.06Zm4.25,0v4.25c0,.59-.48,1.06-1.06,1.06s-1.06-.48-1.06-1.06V6.38c0-.59,.48-1.06,1.06-1.06s1.06,.48,1.06,1.06Z"},
  {id:'pack',tab_name:"小分け",tab_class:'order_pack_tab_help',icon:"M8.54,0h-1.38c-.91,0-1.65,.74-1.65,1.65v3.86c0,1.22,.99,2.2,2.2,2.2h4.41c1.22,0,2.2-.99,2.2-2.2V1.65c0-.91-.74-1.65-1.65-1.65h-1.38V2.76c0,.3-.25,.55-.55,.55h-1.65c-.3,0-.55-.25-.55-.55V0ZM2.2,8.82c-1.22,0-2.2,.99-2.2,2.2v4.41c0,1.22,.99,2.2,2.2,2.2H7.72c1.22,0,2.2-.99,2.2-2.2v-4.41c0-1.22-.99-2.2-2.2-2.2h-1.38v2.76c0,.3-.25,.55-.55,.55h-1.65c-.3,0-.55-.25-.55-.55v-2.76h-1.38Zm9.92,8.82h5.51c1.22,0,2.2-.99,2.2-2.2v-4.41c0-1.22-.99-2.2-2.2-2.2h-1.38v2.76c0,.3-.25,.55-.55,.55h-1.65c-.3,0-.55-.25-.55-.55v-2.76h-1.38c-.52,0-.99,.18-1.37,.48,.17,.36,.27,.76,.27,1.18v5.51c0,.42-.1,.82-.27,1.18,.38,.3,.85,.48,1.37,.48Z"},
  {id:'wait',tab_name:"納品待ち",tab_class:'order_wait_tab_help',icon:"M0,.8C0,.36,.36,0,.8,0H11.96c.44,0,.8,.36,.8,.8s-.36,.8-.8,.8h-.27v.63c0,1.34-.53,2.62-1.48,3.57l-2.71,2.71,2.71,2.71c.95,.95,1.48,2.23,1.48,3.57v.63h.27c.44,0,.8,.36,.8,.8s-.36,.8-.8,.8H.8c-.44,0-.8-.36-.8-.8s.36-.8,.8-.8h.27v-.63c0-1.34,.53-2.62,1.48-3.57l2.71-2.71-2.71-2.71c-.95-.95-1.48-2.23-1.48-3.57v-.63h-.27c-.44,0-.8-.36-.8-.8ZM3.67,12.34c-.13,.13-.25,.27-.36,.42h6.13c-.11-.15-.23-.29-.36-.42l-2.71-2.71-2.71,2.71h0ZM9.44,4.25c.43-.58,.66-1.3,.66-2.03v-.63H2.66v.63c0,.73,.23,1.44,.66,2.03h6.13Z"},
  {id:'defect',tab_name:"未納品削除",tab_class:'order_defect_tab_help',icon:"M2.43,0C1.09,0,0,1.09,0,2.43V14.58c0,1.34,1.09,2.43,2.43,2.43H14.58c1.34,0,2.43-1.09,2.43-2.43V2.43c0-1.34-1.09-2.43-2.43-2.43H2.43Zm3,5.43c.36-.36,.93-.36,1.29,0l1.78,1.78,1.78-1.78c.36-.36,.93-.36,1.29,0s.36,.93,0,1.29l-1.78,1.78,1.78,1.78c.36,.36,.36,.93,0,1.29s-.93,.36-1.29,0l-1.78-1.78-1.78,1.78c-.36,.36-.93,.36-1.29,0s-.36-.93,0-1.29l1.78-1.78-1.78-1.78c-.36-.36-.36-.93,0-1.29Z"},
  {id:'today',tab_name:"当日納品確認済み",tab_class:'order_today_tab_help',icon:"M8.5,17.01c4.7,0,8.5-3.81,8.5-8.5S13.2,0,8.5,0,0,3.81,0,8.5s3.81,8.5,8.5,8.5Zm3.75-10.07l-4.25,4.25c-.31,.31-.82,.31-1.13,0l-2.13-2.13c-.31-.31-.31-.82,0-1.13s.82-.31,1.13,0l1.56,1.56,3.69-3.69c.31-.31,.82-.31,1.13,0s.31,.82,0,1.13h0Z"},
  {id:'today_pack',tab_name:"当日小分け発送済み",tab_class:'order_today_pack_tab_help',icon:"M3.5,0c-.83,0-1.5,.67-1.5,1.5v1.5H.5c-.28,0-.5,.22-.5,.5s.22,.5,.5,.5H8.5c.27,0,.5,.22,.5,.5s-.23,.5-.5,.5H1.5c-.27,0-.5,.22-.5,.5s.23,.5,.5,.5H7.5c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5H.5c-.28,0-.5,.22-.5,.5s.22,.5,.5,.5H6.5c.28,0,.5,.23,.5,.5s-.22,.5-.5,.5H2v4c0,1.66,1.34,3,3,3s3-1.34,3-3h4c0,1.66,1.34,3,3,3s3-1.34,3-3h1c.55,0,1-.45,1-1s-.45-1-1-1v-3.58c0-.53-.21-1.04-.58-1.42l-2.42-2.42c-.38-.38-.88-.58-1.42-.58h-1.58V1.5c0-.83-.67-1.5-1.5-1.5H3.5Zm13.5,7.42v.58h-4v-3h1.58l2.42,2.42ZM5,11.5c.83,0,1.5,.67,1.5,1.5s-.67,1.5-1.5,1.5-1.5-.67-1.5-1.5,.67-1.5,1.5-1.5Zm8.5,1.5c0-.83,.67-1.5,1.5-1.5s1.5,.67,1.5,1.5-.67,1.5-1.5,1.5-1.5-.67-1.5-1.5Z"},
]
const getOrderCount = async () => {
  let params = {};
  const paramsSerializer = (params) => qs.stringify(params);
  try {
    const response = await axios.get(props.apis.pharmacy_order_count,{params:params,paramsSerializer});
    order.order_count = response.data.order_count;
    order.order_max_number_days = response.data.order_max_number_days;
    order.order_hold_count = response.data.order_hold_count;
    order.order_pack_count = response.data.order_pack_count;
    order.order_pack_submit_count = response.data.order_pack_submit_count;
    order.order_wait_count = response.data.order_wait_count;
    order.order_defect_count = response.data.order_defect_count;
    order.order_today_count = response.data.order_today_count;
    order.order_today_pack_count = response.data.order_today_pack_count;
  } finally {
  }
}
// 発注メニューの開閉管理status
const isOpen = ref(false);
// モバイルのみ表示する為のstatus
const isMobile: boolean = Breakpoint().isBelow('sm');

onMounted(() => {
  getOrderCount();
  activeTab.value = 'order';
});

// 発注メニューの開閉管理
const toggleAccordion = () => {
  isOpen.value = !isOpen.value;
}

const updatePackListComplete = () => {
  getOrderCount();
}
</script>

<style scoped>
.active {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
  --tw-border-opacity: 1;
  border-color: rgb(242 140 31 / var(--tw-border-opacity));
  border-bottom-width: 2px;
}
.active > svg {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
}
a.active:hover {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
}
.active > svg:hover {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
}
</style>
<template>
<div ref="element" class="relative">
  <div id="order_header" class="border-gray-200 dark:border-gray-700">
    <div class="absolute top-2 right-2">
      <help-action
        help-key="order_main_help"
      ></help-action>
    </div>
    <div>
      <button v-if="isMobile" @click="toggleAccordion" class="flex items-center justify-center w-full py-2 px-4 text-gray-800 border text-left">
        <img class="w-7 h-7" src="../../../../public/images/icon/order_work.png" alt="発注作業メニュー">
        <div class="mx-3">発注作業メニュー</div>
        <div class="pull-down-icon" :class="{ 'rotate-180': isOpen }"></div>
      </button>
    </div>
    <ul v-if="!isMobile || isOpen" class="flex flex-wrap -mb-px text-sm font-medium border-x border-b md:border-none text-center text-gray-500 dark:text-gray-400">
        <li class="mr-2" v-for="tab in activeTabs" :key="tab.id">
            <a href="javascript:void(0)" @click="activeTab = tab.id" :class="tab.tab_class + ' ' + (activeTab == tab.id ? 'active ' : '') + 'inline-flex pt-4 pr-2 pl-2 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group'">
                <svg aria-hidden="true" class="w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" :d="tab.icon"></path></svg>
                {{ tab.tab_name }}
                <span v-if="tab.id == 'order'" class="relative">
                  ({{ order.order_count }})
                  <div v-show="(order.get_editing_ids('is_auto').length > 0)" class="inline-flex absolute -top-4 -right-4 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-orange-500 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-regular fa-pen-to-square"></i></div>
                  <span v-show="order.order_max_number_days > 0" class="font-bold text-red-700 text-lg">({{ order.order_max_number_days }})</span>
                </span>
                <span v-else-if="tab.id == 'hold'">({{ order.order_hold_count }})</span>
                <span v-else-if="tab.id == 'pack'" class="relative">
                  <div v-show="(order.get_editing_ids('is_pack_submit_wait').length > 0)" class="inline-flex absolute -top-4 -right-4 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-orange-500 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-regular fa-pen-to-square"></i></div>
                  <span>({{ order.order_pack_count }})</span>
                  <span v-if="order.order_pack_submit_count > 0" class="font-bold text-red-700 text-lg">({{ order.order_pack_submit_count }})</span>
                </span>
                <span v-else-if="tab.id == 'wait'" class="relative">
                  ({{ order.order_wait_count }})
                  <div v-show="order.get_editing_ids('is_wait').length > 0" class="inline-flex absolute -top-4 -right-4 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-orange-500 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-regular fa-pen-to-square"></i></div>
                </span>
                <span v-else-if="tab.id == 'defect'">({{ order.order_defect_count }})</span>
                <span v-else-if="tab.id == 'today'">({{ order.order_today_count }})</span>
                <span v-else-if="tab.id == 'today_pack'">({{ order.order_today_pack_count }})</span>
            </a>
        </li>
    </ul>
  </div>
  <order-list-component
    :apis="apis"
    :pharmacy-wholesalers="pharmacyWholesalers"
    :is-visible="activeTab == 'order'"
    :params="params"
  ></order-list-component>
  <order-hold-list-component
    :apis="apis"
    :pharmacy-wholesalers="pharmacyWholesalers"
    :is-visible="activeTab == 'hold'"
  ></order-hold-list-component>
  <order-pack-list-component
    :apis="apis"
    :pharmacy-wholesalers="pharmacyWholesalers"
    :is-visible="activeTab == 'pack'"
    :update-complete="updatePackListComplete"
  ></order-pack-list-component>
  <order-wait-list-component
    :apis="apis"
    :pharmacy-wholesalers="pharmacyWholesalers"
    :is-visible="activeTab == 'wait'"
  ></order-wait-list-component>
  <order-defect-list-component
    :apis="apis"
    :pharmacy-wholesalers="pharmacyWholesalers"
    :is-visible="activeTab == 'defect'"
  ></order-defect-list-component>
  <order-today-list-component
    :apis="apis"
    :pharmacy-wholesalers="pharmacyWholesalers"
    :is-visible="activeTab == 'today'"
  ></order-today-list-component>
  <order-today-pack-list-component
    :apis="apis"
    :pharmacy-wholesalers="pharmacyWholesalers"
    :is-visible="activeTab == 'today_pack'"
  ></order-today-pack-list-component>

</div>
</template>

